<template>
  <v-container class="pa-0 my-10 no-concepts-container">
    <p v-if="store.searchType === 'classic'">
      Aucun concept ne correspond aux termes de recherche spécifiés<span class="font-weight-bold" v-if="store.search"> :
        {{ store.search }}</span>.
    </p>
    <p v-else>
      Aucun concept ne correspond aux termes de recherche avancée spécifiés.
    </p>
    <p class="mx-0 mt-5 mb-2">Suggestions :</p>
    <ul>
      <li>
        <ConceptSuggestions :suggestions="store.suggestions" />
      </li>
      <li>Vérifiez l'orthographe des termes de recherche.</li>
      <li>Essayer d'autres termes.</li>
      <li>Utilisez des mots clés plus généraux</li>
    </ul>
  </v-container>
</template>

<script>
import ConceptsStore from "../concepts-store";
import ConceptSuggestions from './ConceptSuggestions';

export default {
  name: "NoConcepts",

  components: {
    ConceptSuggestions,
  },
  data() {
    return {
      store: ConceptsStore.state,
    }
  },
}
</script>

<style scoped lang="scss">
.no-concepts-container {
  max-width: 700px
}


.suggestions {
  > :not(:last-child)::after {
    content: ", ";
  }
}
</style>